<template>
  <div class="w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-4">
    <vs-card
      id="load-order-cards-loading"
      class="vs-con-loading__container px-2 widget-card"
    >
      <card-header :title="$t('widget_load_order_by_status')"></card-header>

      <vs-row>
        <vs-col vs-w="12" class="mt-5">
          <statistics-card-line
            icon="MapPinIcon"
            icon-right
            :statistic="cards.readyToLoad"
            statisticTitle="Ready to Load"
            :hideChart="true"
            color="info"
          />
        </vs-col>
        <vs-col vs-w="12" class="mt-5">
          <statistics-card-line
            icon="MapPinIcon"
            icon-right
            :statistic="cards.onLoad"
            statisticTitle="On Load"
            :hideChart="true"
            color="warning"
          />
        </vs-col>
        <vs-col vs-w="12" class="mt-5">
          <statistics-card-line
            icon="PackageIcon"
            icon-right
            :statistic="cards.shipped"
            statisticTitle="Shipped"
            :hideChart="true"
            color="success"
          />
        </vs-col>
      </vs-row>
    </vs-card>
  </div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import loadOrder from '@/http/requests/loadOrder'
import loading from '@/mixins/Loading'
import CardHeader from './CardHeader.vue'

export default {
  components: {
    StatisticsCardLine,
    CardHeader,
  },
  mixins: [loading],
  computed: {
    isLoading() {
      return this.loading.cards
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('load-order-cards-loading')
      } else {
        this.closeLoading('load-order-cards-loading')
      }
    },
  },

  data() {
    return {
      cards: {
        onLoad: 0,
        readyToLoad: 0,
        shipped: 0,
      },
      loading: {
        cards: false,
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading.cards = true
      loadOrder
        .getBadget()
        .then((res) => {
          this.cards.onLoad = res.data[0].total
          this.cards.readyToLoad = res.data[1].total
          this.cards.shipped = res.data[2].total
          this.loading.cards = false
        })
        .catch((err) => {
          console.log(err)
          this.loading.cards = false
        })
    },
  },
}
</script>